<template>
  <div class="q-mx-auto q-pa-sm">
    <q-card flat>
      <div class="q-pb-xs">
        <StockAlphaBeta :symbol="symbol" />
      </div>
      <div class="row">
        <div class="col-md-6 col-12">
          <StockWiseEssentialStatistics class="q-mb-sm" :symbol="symbol" />
        </div>
        <div class="col-md-6 col-12 q-pl-md-sm q-mt-sm q-mt-md-none">
          <StockWiseSignalStatus :symbol="symbol" v-if="symbol" />
        </div>
      </div>
    </q-card>
  </div>
</template>
<script>
import StockAlphaBeta from "src/components/StockAlphaBeta.vue";

import StockWiseSignalStatus from "src/components/StockWiseSignalStatus.vue";
import StockWiseEssentialStatistics from "src/components/StockWiseEssentialStatistics.vue";

export default {
  name: "StockBasicInfoOnly",
  props: {
    symbol: {
      type: String,
      required: true,
    },
  },
  components: {
    StockWiseSignalStatus,
    StockWiseEssentialStatistics,
    StockAlphaBeta,
  },

  setup(props) {},
};
</script>
